/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AddStageParticipantsRequestDto } from '../models';
// @ts-ignore
import type { AvailableTermParticipantsResponseDto } from '../models';
// @ts-ignore
import type { InlineObjectDto } from '../models';
// @ts-ignore
import type { ParticipantStageStatusDto } from '../models';
// @ts-ignore
import type { TestTermParticipantsResponseDto } from '../models';
/**
 * TestTermParticipantApi - axios parameter creator
 * @export
 */
export const TestTermParticipantApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Adds employees from the stage participant pool to this test term. Validates that employees are stage participants and term is not COMPLETED/CANCELLED. 
         * @summary Add participants to test term
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} termId 
         * @param {AddStageParticipantsRequestDto} addStageParticipantsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTestTermParticipants: async (certificationId: number, stageId: number, termId: number, addStageParticipantsRequestDto: AddStageParticipantsRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('addTestTermParticipants', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('addTestTermParticipants', 'stageId', stageId)
            // verify required parameter 'termId' is not null or undefined
            assertParamExists('addTestTermParticipants', 'termId', termId)
            // verify required parameter 'addStageParticipantsRequestDto' is not null or undefined
            assertParamExists('addTestTermParticipants', 'addStageParticipantsRequestDto', addStageParticipantsRequestDto)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/terms/{termId}/participants`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)))
                .replace(`{${"termId"}}`, encodeURIComponent(String(termId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addStageParticipantsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns paginated list of certification\'s employees who can be added to this term — wszystkich z certyfikacji (z dowolnego etapu, dedup po employeeId) minus tych już przypisanych do termu. Każdy item ma `participantId` = id `certification_stage_participant` w TEST-stage\'u jeśli istnieje, else `null` (backend doda przy klikaniu „+\"). 
         * @summary Get available participants for a test term
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} termId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] Filter by employee firstName/lastName/SAP (partial match)
         * @param {Array<ParticipantStageStatusDto>} [testStatuses] Filter by computed test summary status across this stage\&#39;s terms. Multi-value (CSV) - OR. Allowed: NONE, PASSED, FAILED, IN_PROGRESS, CANCELLED. 
         * @param {Array<string>} [regions] Filter by employee region code (&#x60;employee.area&#x60;, np. \&quot;R16\&quot;). Multi-value (CSV) - OR. Puste / brak parametru → bez filtra. 
         * @param {boolean} [onlyAvailable] Jeśli &#x60;true&#x60;, ukrywa kandydatów którzy są już w innym terminie tego etapu w ten sam dzień co aktualny term (czyli mają &#x60;conflict !&#x3D; null&#x60;). Domyślnie &#x60;false&#x60;. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestTermAvailableParticipants: async (certificationId: number, stageId: number, termId: number, page?: number, pageSize?: number, search?: string, testStatuses?: Array<ParticipantStageStatusDto>, regions?: Array<string>, onlyAvailable?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('getTestTermAvailableParticipants', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('getTestTermAvailableParticipants', 'stageId', stageId)
            // verify required parameter 'termId' is not null or undefined
            assertParamExists('getTestTermAvailableParticipants', 'termId', termId)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/terms/{termId}/available-participants`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)))
                .replace(`{${"termId"}}`, encodeURIComponent(String(termId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (testStatuses) {
                localVarQueryParameter['testStatuses'] = testStatuses.join(COLLECTION_FORMATS.csv);
            }

            if (regions) {
                localVarQueryParameter['regions'] = regions.join(COLLECTION_FORMATS.csv);
            }

            if (onlyAvailable !== undefined) {
                localVarQueryParameter['onlyAvailable'] = onlyAvailable;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns paginated list of employees assigned to this test term. Supports search by employee name/email (partial match). 
         * @summary Get test term participants
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} termId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] Filter by employee name or email (partial match)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestTermParticipants: async (certificationId: number, stageId: number, termId: number, page?: number, pageSize?: number, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('getTestTermParticipants', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('getTestTermParticipants', 'stageId', stageId)
            // verify required parameter 'termId' is not null or undefined
            assertParamExists('getTestTermParticipants', 'termId', termId)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/terms/{termId}/participants`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)))
                .replace(`{${"termId"}}`, encodeURIComponent(String(termId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove participant from test term
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} termId 
         * @param {number} participantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeTestTermParticipant: async (certificationId: number, stageId: number, termId: number, participantId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('removeTestTermParticipant', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('removeTestTermParticipant', 'stageId', stageId)
            // verify required parameter 'termId' is not null or undefined
            assertParamExists('removeTestTermParticipant', 'termId', termId)
            // verify required parameter 'participantId' is not null or undefined
            assertParamExists('removeTestTermParticipant', 'participantId', participantId)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/terms/{termId}/participants/{participantId}`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)))
                .replace(`{${"termId"}}`, encodeURIComponent(String(termId)))
                .replace(`{${"participantId"}}`, encodeURIComponent(String(participantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TestTermParticipantApi - functional programming interface
 * @export
 */
export const TestTermParticipantApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TestTermParticipantApiAxiosParamCreator(configuration)
    return {
        /**
         * Adds employees from the stage participant pool to this test term. Validates that employees are stage participants and term is not COMPLETED/CANCELLED. 
         * @summary Add participants to test term
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} termId 
         * @param {AddStageParticipantsRequestDto} addStageParticipantsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addTestTermParticipants(certificationId: number, stageId: number, termId: number, addStageParticipantsRequestDto: AddStageParticipantsRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addTestTermParticipants(certificationId, stageId, termId, addStageParticipantsRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestTermParticipantApi.addTestTermParticipants']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns paginated list of certification\'s employees who can be added to this term — wszystkich z certyfikacji (z dowolnego etapu, dedup po employeeId) minus tych już przypisanych do termu. Każdy item ma `participantId` = id `certification_stage_participant` w TEST-stage\'u jeśli istnieje, else `null` (backend doda przy klikaniu „+\"). 
         * @summary Get available participants for a test term
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} termId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] Filter by employee firstName/lastName/SAP (partial match)
         * @param {Array<ParticipantStageStatusDto>} [testStatuses] Filter by computed test summary status across this stage\&#39;s terms. Multi-value (CSV) - OR. Allowed: NONE, PASSED, FAILED, IN_PROGRESS, CANCELLED. 
         * @param {Array<string>} [regions] Filter by employee region code (&#x60;employee.area&#x60;, np. \&quot;R16\&quot;). Multi-value (CSV) - OR. Puste / brak parametru → bez filtra. 
         * @param {boolean} [onlyAvailable] Jeśli &#x60;true&#x60;, ukrywa kandydatów którzy są już w innym terminie tego etapu w ten sam dzień co aktualny term (czyli mają &#x60;conflict !&#x3D; null&#x60;). Domyślnie &#x60;false&#x60;. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTestTermAvailableParticipants(certificationId: number, stageId: number, termId: number, page?: number, pageSize?: number, search?: string, testStatuses?: Array<ParticipantStageStatusDto>, regions?: Array<string>, onlyAvailable?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AvailableTermParticipantsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTestTermAvailableParticipants(certificationId, stageId, termId, page, pageSize, search, testStatuses, regions, onlyAvailable, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestTermParticipantApi.getTestTermAvailableParticipants']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns paginated list of employees assigned to this test term. Supports search by employee name/email (partial match). 
         * @summary Get test term participants
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} termId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] Filter by employee name or email (partial match)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTestTermParticipants(certificationId: number, stageId: number, termId: number, page?: number, pageSize?: number, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestTermParticipantsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTestTermParticipants(certificationId, stageId, termId, page, pageSize, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestTermParticipantApi.getTestTermParticipants']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove participant from test term
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} termId 
         * @param {number} participantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeTestTermParticipant(certificationId: number, stageId: number, termId: number, participantId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeTestTermParticipant(certificationId, stageId, termId, participantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestTermParticipantApi.removeTestTermParticipant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TestTermParticipantApi - factory interface
 * @export
 */
export const TestTermParticipantApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TestTermParticipantApiFp(configuration)
    return {
        /**
         * Adds employees from the stage participant pool to this test term. Validates that employees are stage participants and term is not COMPLETED/CANCELLED. 
         * @summary Add participants to test term
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} termId 
         * @param {AddStageParticipantsRequestDto} addStageParticipantsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTestTermParticipants(certificationId: number, stageId: number, termId: number, addStageParticipantsRequestDto: AddStageParticipantsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addTestTermParticipants(certificationId, stageId, termId, addStageParticipantsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns paginated list of certification\'s employees who can be added to this term — wszystkich z certyfikacji (z dowolnego etapu, dedup po employeeId) minus tych już przypisanych do termu. Każdy item ma `participantId` = id `certification_stage_participant` w TEST-stage\'u jeśli istnieje, else `null` (backend doda przy klikaniu „+\"). 
         * @summary Get available participants for a test term
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} termId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] Filter by employee firstName/lastName/SAP (partial match)
         * @param {Array<ParticipantStageStatusDto>} [testStatuses] Filter by computed test summary status across this stage\&#39;s terms. Multi-value (CSV) - OR. Allowed: NONE, PASSED, FAILED, IN_PROGRESS, CANCELLED. 
         * @param {Array<string>} [regions] Filter by employee region code (&#x60;employee.area&#x60;, np. \&quot;R16\&quot;). Multi-value (CSV) - OR. Puste / brak parametru → bez filtra. 
         * @param {boolean} [onlyAvailable] Jeśli &#x60;true&#x60;, ukrywa kandydatów którzy są już w innym terminie tego etapu w ten sam dzień co aktualny term (czyli mają &#x60;conflict !&#x3D; null&#x60;). Domyślnie &#x60;false&#x60;. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestTermAvailableParticipants(certificationId: number, stageId: number, termId: number, page?: number, pageSize?: number, search?: string, testStatuses?: Array<ParticipantStageStatusDto>, regions?: Array<string>, onlyAvailable?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<AvailableTermParticipantsResponseDto> {
            return localVarFp.getTestTermAvailableParticipants(certificationId, stageId, termId, page, pageSize, search, testStatuses, regions, onlyAvailable, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns paginated list of employees assigned to this test term. Supports search by employee name/email (partial match). 
         * @summary Get test term participants
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} termId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] Filter by employee name or email (partial match)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestTermParticipants(certificationId: number, stageId: number, termId: number, page?: number, pageSize?: number, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<TestTermParticipantsResponseDto> {
            return localVarFp.getTestTermParticipants(certificationId, stageId, termId, page, pageSize, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove participant from test term
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} termId 
         * @param {number} participantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeTestTermParticipant(certificationId: number, stageId: number, termId: number, participantId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeTestTermParticipant(certificationId, stageId, termId, participantId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TestTermParticipantApi - interface
 * @export
 * @interface TestTermParticipantApi
 */
export interface TestTermParticipantApiInterface {
    /**
     * Adds employees from the stage participant pool to this test term. Validates that employees are stage participants and term is not COMPLETED/CANCELLED. 
     * @summary Add participants to test term
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {number} termId 
     * @param {AddStageParticipantsRequestDto} addStageParticipantsRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestTermParticipantApiInterface
     */
    addTestTermParticipants(certificationId: number, stageId: number, termId: number, addStageParticipantsRequestDto: AddStageParticipantsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Returns paginated list of certification\'s employees who can be added to this term — wszystkich z certyfikacji (z dowolnego etapu, dedup po employeeId) minus tych już przypisanych do termu. Każdy item ma `participantId` = id `certification_stage_participant` w TEST-stage\'u jeśli istnieje, else `null` (backend doda przy klikaniu „+\"). 
     * @summary Get available participants for a test term
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {number} termId 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {string} [search] Filter by employee firstName/lastName/SAP (partial match)
     * @param {Array<ParticipantStageStatusDto>} [testStatuses] Filter by computed test summary status across this stage\&#39;s terms. Multi-value (CSV) - OR. Allowed: NONE, PASSED, FAILED, IN_PROGRESS, CANCELLED. 
     * @param {Array<string>} [regions] Filter by employee region code (&#x60;employee.area&#x60;, np. \&quot;R16\&quot;). Multi-value (CSV) - OR. Puste / brak parametru → bez filtra. 
     * @param {boolean} [onlyAvailable] Jeśli &#x60;true&#x60;, ukrywa kandydatów którzy są już w innym terminie tego etapu w ten sam dzień co aktualny term (czyli mają &#x60;conflict !&#x3D; null&#x60;). Domyślnie &#x60;false&#x60;. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestTermParticipantApiInterface
     */
    getTestTermAvailableParticipants(certificationId: number, stageId: number, termId: number, page?: number, pageSize?: number, search?: string, testStatuses?: Array<ParticipantStageStatusDto>, regions?: Array<string>, onlyAvailable?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<AvailableTermParticipantsResponseDto>;

    /**
     * Returns paginated list of employees assigned to this test term. Supports search by employee name/email (partial match). 
     * @summary Get test term participants
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {number} termId 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {string} [search] Filter by employee name or email (partial match)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestTermParticipantApiInterface
     */
    getTestTermParticipants(certificationId: number, stageId: number, termId: number, page?: number, pageSize?: number, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<TestTermParticipantsResponseDto>;

    /**
     * 
     * @summary Remove participant from test term
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {number} termId 
     * @param {number} participantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestTermParticipantApiInterface
     */
    removeTestTermParticipant(certificationId: number, stageId: number, termId: number, participantId: number, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * TestTermParticipantApi - object-oriented interface
 * @export
 * @class TestTermParticipantApi
 * @extends {BaseAPI}
 */
export class TestTermParticipantApi extends BaseAPI implements TestTermParticipantApiInterface {
    /**
     * Adds employees from the stage participant pool to this test term. Validates that employees are stage participants and term is not COMPLETED/CANCELLED. 
     * @summary Add participants to test term
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {number} termId 
     * @param {AddStageParticipantsRequestDto} addStageParticipantsRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestTermParticipantApi
     */
    public addTestTermParticipants(certificationId: number, stageId: number, termId: number, addStageParticipantsRequestDto: AddStageParticipantsRequestDto, options?: RawAxiosRequestConfig) {
        return TestTermParticipantApiFp(this.configuration).addTestTermParticipants(certificationId, stageId, termId, addStageParticipantsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns paginated list of certification\'s employees who can be added to this term — wszystkich z certyfikacji (z dowolnego etapu, dedup po employeeId) minus tych już przypisanych do termu. Każdy item ma `participantId` = id `certification_stage_participant` w TEST-stage\'u jeśli istnieje, else `null` (backend doda przy klikaniu „+\"). 
     * @summary Get available participants for a test term
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {number} termId 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {string} [search] Filter by employee firstName/lastName/SAP (partial match)
     * @param {Array<ParticipantStageStatusDto>} [testStatuses] Filter by computed test summary status across this stage\&#39;s terms. Multi-value (CSV) - OR. Allowed: NONE, PASSED, FAILED, IN_PROGRESS, CANCELLED. 
     * @param {Array<string>} [regions] Filter by employee region code (&#x60;employee.area&#x60;, np. \&quot;R16\&quot;). Multi-value (CSV) - OR. Puste / brak parametru → bez filtra. 
     * @param {boolean} [onlyAvailable] Jeśli &#x60;true&#x60;, ukrywa kandydatów którzy są już w innym terminie tego etapu w ten sam dzień co aktualny term (czyli mają &#x60;conflict !&#x3D; null&#x60;). Domyślnie &#x60;false&#x60;. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestTermParticipantApi
     */
    public getTestTermAvailableParticipants(certificationId: number, stageId: number, termId: number, page?: number, pageSize?: number, search?: string, testStatuses?: Array<ParticipantStageStatusDto>, regions?: Array<string>, onlyAvailable?: boolean, options?: RawAxiosRequestConfig) {
        return TestTermParticipantApiFp(this.configuration).getTestTermAvailableParticipants(certificationId, stageId, termId, page, pageSize, search, testStatuses, regions, onlyAvailable, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns paginated list of employees assigned to this test term. Supports search by employee name/email (partial match). 
     * @summary Get test term participants
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {number} termId 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {string} [search] Filter by employee name or email (partial match)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestTermParticipantApi
     */
    public getTestTermParticipants(certificationId: number, stageId: number, termId: number, page?: number, pageSize?: number, search?: string, options?: RawAxiosRequestConfig) {
        return TestTermParticipantApiFp(this.configuration).getTestTermParticipants(certificationId, stageId, termId, page, pageSize, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove participant from test term
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {number} termId 
     * @param {number} participantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestTermParticipantApi
     */
    public removeTestTermParticipant(certificationId: number, stageId: number, termId: number, participantId: number, options?: RawAxiosRequestConfig) {
        return TestTermParticipantApiFp(this.configuration).removeTestTermParticipant(certificationId, stageId, termId, participantId, options).then((request) => request(this.axios, this.basePath));
    }
}

